document.addEventListener('DOMContentLoaded', function () {
  const lightbox = document.getElementById('lightbox');
  const lightboxImg = document.getElementById('lightbox-img');
  const lightboxThumbs = document.getElementById('lightbox-thumbnails');
  const closeBtn = document.querySelector('.close');
  const prevBtn = document.getElementById('prev');
  const nextBtn = document.getElementById('next');

  let currentImages = [];
  let currentIndex = 0;

  // Touch swipe variables
  let touchStartX = 0;
  let touchEndX = 0;

  function openLightbox(reviewId, startIndex = 0) {
    const reviewPhotos = document.querySelector(`.review-photos[data-review-id="${reviewId}"]`);
    if (!reviewPhotos) return;

    currentImages = Array.from(reviewPhotos.querySelectorAll('img')).map(img => img.src);
    if (currentImages.length === 0) return;

    currentIndex = startIndex;

    lightboxThumbs.innerHTML = '';
    currentImages.forEach((src, idx) => {
      const thumb = document.createElement('img');
      thumb.src = src;
      if (idx === currentIndex) thumb.classList.add('active');
      thumb.addEventListener('click', () => {
        currentIndex = idx;
        showLightbox(currentIndex);
      });
      lightboxThumbs.appendChild(thumb);
    });

    showLightbox(currentIndex);
    lightbox.style.display = 'flex';
  }

  function showLightbox(index) {
    if (currentImages.length === 0) return;
    lightboxImg.style.opacity = 0;
    lightboxImg.src = currentImages[index];
    setTimeout(() => { lightboxImg.style.opacity = 1; }, 50);

    Array.from(lightboxThumbs.children).forEach((thumb, idx) => {
      thumb.classList.toggle('active', idx === index);
    });
  }

  // Click events
  document.querySelectorAll('.gallery-image').forEach(img => {
    img.addEventListener('click', function () {
      openLightbox(this.dataset.reviewId, parseInt(this.dataset.imageIndex));
    });
  });

  document.querySelectorAll('.overlay[data-first-hidden]').forEach(overlay => {
    overlay.addEventListener('click', function () {
      const reviewId = this.closest('.review-photos').dataset.reviewId;
      const firstHiddenIndex = parseInt(this.dataset.firstHidden);
      openLightbox(reviewId, firstHiddenIndex);
    });
  });

  // Navigation buttons
  nextBtn.addEventListener('click', () => {
    if (currentImages.length === 0) return;
    currentIndex = (currentIndex + 1) % currentImages.length;
    showLightbox(currentIndex);
  });

  prevBtn.addEventListener('click', () => {
    if (currentImages.length === 0) return;
    currentIndex = (currentIndex - 1 + currentImages.length) % currentImages.length;
    showLightbox(currentIndex);
  });

  // Close
  closeBtn.addEventListener('click', () => lightbox.style.display = 'none');
  lightbox.addEventListener('click', e => { if(e.target === lightbox) lightbox.style.display = 'none'; });

  // Keyboard
  document.addEventListener('keydown', (e) => {
    if(lightbox.style.display === 'flex'){
      if(e.key === 'ArrowRight') nextBtn.click();
      if(e.key === 'ArrowLeft') prevBtn.click();
      if(e.key === 'Escape') closeBtn.click();
    }
  });

  // -------------------
  // Mobile swipe support
  // -------------------
  lightboxImg.addEventListener('touchstart', function(e) {
    touchStartX = e.changedTouches[0].screenX;
  });

  lightboxImg.addEventListener('touchend', function(e) {
    touchEndX = e.changedTouches[0].screenX;
    handleSwipeGesture();
  });

  function handleSwipeGesture() {
    const swipeDistance = touchEndX - touchStartX;
    const minDistance = 40; // Minimum px for swipe

    if (Math.abs(swipeDistance) > minDistance) {
      if (swipeDistance < 0) nextBtn.click(); // Swipe left → next
      if (swipeDistance > 0) prevBtn.click(); // Swipe right → prev
    }
  }
});
